import { GENERIC_ERROR_MESSAGE } from "./constants";

/**
 * Pull the first human-readable message out of a DRF error response.
 *
 * DRF answers validation failures with `{ field: ["msg"], ... }`,
 * `{ non_field_errors: ["msg"] }`, `{ detail: "msg" }` or `{ error: "msg" }`.
 * This walks whatever shape came back and returns the first string it finds.
 *
 * @param {unknown} error Axios error (or anything else that was thrown)
 * @param {string} fallback Message when nothing usable is present
 * @returns {string}
 */
export const extractErrorMessage = (error, fallback = GENERIC_ERROR_MESSAGE) => {
  const firstString = (value) => {
    if (typeof value === "string") {
      return value;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        const found = firstString(item);
        if (found) {
          return found;
        }
      }
      return null;
    }
    if (value && typeof value === "object") {
      for (const item of Object.values(value)) {
        const found = firstString(item);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  return firstString(error?.response?.data) || fallback;
};
